import {Directive} from '@angular/core';

@Directive({
  selector: '[cfFamilyProductContent]',
})
export class FamilyProductContentDirective {

  constructor() {
  }

}
